(function () {
  const controlMegaMenu = (header) => {
    const megaMenuLinks = header.querySelectorAll(".list-menu--megamenu");
    if (!megaMenuLinks || !megaMenuLinks.length) return;

    megaMenuLinks.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        link.classList.add("list-menu--megamenu-visible");

        link.addEventListener("mousemove", () => {
          link.classList.add("list-menu--megamenu-visible");
        });

        link.addEventListener("mouseleave", () => {
          link.classList.remove("list-menu--megamenu-visible");
          link.addEventListener("mouseenter", () => {
            link.classList.add("list-menu--megamenu-visible");
          });
        });
      });
    });
  };

  const calcMegaMenuPosition = (header) => {
    const isBottomMenuType = Boolean(
      header.querySelector("header.header--bottom-menu")
    );
    if (!isBottomMenuType) return;

    const megaMenuLinks = header.querySelectorAll(".list-menu--megamenu");
    if (!megaMenuLinks || !megaMenuLinks.length) return;

    const headerBottom = header.querySelector(".header__bottom");
    if (!headerBottom) return;

    const headerBottomRect = headerBottom.getBoundingClientRect();

    megaMenuLinks.forEach((link) => {
      const menuLi = link.querySelector(".header__mega-menu");
      const headerLi = link.querySelector(".header__menu-item");

      if (!menuLi || !headerLi) return;

      const headerRect = headerLi.getBoundingClientRect();

      const verticalDistance = Math.abs(
        headerRect.bottom - headerBottomRect.bottom
      );

      menuLi.style.top = `calc(100% - ${verticalDistance}px)`;
    });
  };

  const controlMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(".list-menu--megasubmenu");
    megaSubmenuLinks.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        link.classList.add("list-menu--megasubmenu-visible");

        link.addEventListener("mousemove", () => {
          link.classList.add("list-menu--megasubmenu-visible");
        });

        link.addEventListener("mouseleave", () => {
          link.classList.remove("list-menu--megasubmenu-visible");
          link.addEventListener("mouseenter", () => {
            link.classList.add("list-menu--megasubmenu-visible");
          });
        });
      });

      const tabs = link.querySelectorAll(".mega-submenu__tab");
      const submenus = link.querySelectorAll(".mega-submenu__submenu");

      const onToggle = (event) => {
        const tab = event.target;
        if (!tab || !tab.classList.contains("mega-submenu__tab")) return;
        const tabId = tab.dataset.tabId;

        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        submenus.forEach((submenu) => {
          submenu.classList.remove("active");
          if (submenu.dataset.tabId === tabId) {
            submenu.classList.add("active");
          }
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener("click", onToggle);
        tab.addEventListener("mouseenter", onToggle);
      });
    });
  };

  const checkMegaSubmenuPosition = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(".list-menu--megasubmenu");
    const headerRect = header.getBoundingClientRect();

    megaSubmenuLinks.forEach((link) => {
      const megaSubmenu = link.querySelector(".mega-submenu");
      megaSubmenu.style.removeProperty("max-width");

      const linkRect = link.getBoundingClientRect();
      const availableWidth = headerRect.right - linkRect.left;
      if (availableWidth < 1000) {
        megaSubmenu.style.maxWidth = `calc(${availableWidth}px - 16px)`;
      }
    });
  };

  const calcHeaderHeightTop = (header) => {
    const headerTop = document.querySelector(
      ".shopify-section-header .header__top"
    );
    if (!headerTop) return;

    const headerTopHeight = header.getBoundingClientRect().height.toFixed(4);
    document.documentElement.style.setProperty(
      "--header-height-top",
      `${headerTopHeight}px`
    );
  };

  const calcSearchModalPosition = (header) => {
    const headerWrapper = header.querySelector(".header-wrapper ");
    const searchEl = header.querySelector(".header__search.search");
    const searchModal = searchEl.querySelector(".search__modal");
    if (!headerWrapper || !searchEl || !searchModal) return;

    searchModal.style.removeProperty("left");

    const searchElRect = searchEl.getBoundingClientRect();
    const searchModalRect = searchModal.getBoundingClientRect();
    const headerRect = headerWrapper.getBoundingClientRect();

    if (window.innerWidth >= 1100 && searchModalRect.right > headerRect.right) {
      const searchElCenter = searchElRect.left + searchElRect.width / 2;
      const desiredLeft = searchElCenter - searchModalRect.width / 2;

      let finalLeft = desiredLeft;

      if (finalLeft < headerRect.left) {
        finalLeft = headerRect.right - searchModalRect.width;
      }

      const offsetLeft = finalLeft - searchElRect.left;
      searchModal.style.left = `${offsetLeft}px`;
    }
  };

  const initHeader = () => {
    const header = document.querySelector(".shopify-section-header");
    const headerTop = document.querySelector(
      ".shopify-section-header .header__top"
    );
    const headerSearch = document.querySelector(
      ".shopify-section-header .search__content"
    );
    const headerBottom = document.querySelector(
      ".shopify-section-header .header__bottom"
    );

    if (!header) return;

    controlMegaMenu(header);
    controlMegaSubmenu(header);

    const addBackground = () => {
      if (document.querySelector(".overflow-hidden-drawer")) {
        return;
      }

      if (document.querySelector(".always-show")) {
        return;
      }

      const headerObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
        //if (entry.contentRect.width >= 1100) {
        if (
          header.classList.contains("color-background-3") &&
          !header.classList.contains("shopify-section-header-sticky")
        ) {
          header.classList.remove("color-background-3");
          headerTop.classList.remove("color-background-3");
          headerBottom?.classList?.remove("color-background-3");
          headerSearch.classList.remove("color-background-3");
        }

        if (
          header.classList.contains("section--have-overlay") &&
          !header.classList.contains("shopify-section-header-sticky")
        ) {
          header.classList.add("have-background");
        }
        //}
      });

      headerObserver.observe(header);
    };

    const removeBackground = () => {
      if (
        document.querySelector(".overflow-hidden") ||
        document.querySelector(".overflow-hidden-drawer")
      ) {
        return;
      }

      if (document.querySelector(".always-show")) {
        return;
      }

      const hasOpenDetails = header.querySelector("details[open]") !== null;
      const searchElement = header
        .querySelector(".header__overlay")
        .classList.contains("visible");
      const disclosureElement = header.querySelector(
        ".disclosure__button[aria-expanded='true']"
      );

      if (hasOpenDetails || searchElement || disclosureElement) return;

      const headerObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
        //if (entry.contentRect.width >= 1100) {
        if (
          header.classList.contains("color-background-1") &&
          !header.classList.contains("shopify-section-header-sticky")
        ) {
          header.classList.add("color-background-3");
          headerTop.classList.add("color-background-3");
          headerSearch.classList.add("color-background-3");
          headerBottom?.classList?.add("color-background-3");
        }

        if (
          header.classList.contains("section--have-overlay") &&
          !header.classList.contains("shopify-section-header-sticky")
        ) {
          header.classList.remove("have-background");
        }
        //}
      });

      headerObserver.observe(header);
    };

    const hasOverlay = header.classList.contains("has-overlay");

    if (hasOverlay) {
      header.addEventListener("mouseenter", addBackground);

      header.addEventListener("focus", addBackground);

      header.addEventListener("focusin", addBackground);

      header.addEventListener("mouseleave", removeBackground);

      header.addEventListener("focusout", removeBackground);

      document.addEventListener("click", (e) => {
        if (!header.contains(e.target)) {
          removeBackground();
        }
      });

      document.addEventListener("DOMContentLoaded", () => {
        const firstSection = document.querySelector(
          "main .shopify-section:first-child:not(.not-margin) .section--has-overlay:not(.article-template__header)"
        );
        if (!firstSection) return;
        const headerTop = document.querySelector(
          ".shopify-section-header .header__top"
        );
        const headerSearch = document.querySelector(
          ".shopify-section-header .search__content"
        );
        const headerBottom = document.querySelector(
          ".shopify-section-header .header__bottom"
        );

        let isSectionVisible = false;
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting && !isSectionVisible) {
              isSectionVisible = true;
              headerTop.classList.add("color-background-3");
              headerSearch.classList.add("color-background-3");
              headerBottom.classList.add("color-background-3");
              header.classList.add("entering-section", "color-background-3");
            } else if (!entry.isIntersecting && isSectionVisible) {
              isSectionVisible = false;
              header.classList.remove("entering-section");
            }
          },
          { threshold: 0.15 }
        );

        if (firstSection) {
          observer.observe(firstSection);
        }

        window.addEventListener("scroll", () => {
          if (isSectionVisible) {
            header.classList.add("entering-section", "color-background-3");
            headerTop.classList.add("color-background-3");
            headerBottom.classList.add("color-background-3");
            headerSearch.classList.add("color-background-3");
          }
        });
      });
    }

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        calcMegaMenuPosition(header);
        checkMegaSubmenuPosition(header);
        calcHeaderHeightTop(header);
        calcSearchModalPosition(header);
      });
    });

    observer.observe(header);
  };

  document.addEventListener("DOMContentLoaded", initHeader);
  document.addEventListener("shopify:section:load", initHeader);
})();
